import { render, staticRenderFns } from "./TgCjNews.vue?vue&type=template&id=d6c924a8&"
import script from "./TgCjNews.vue?vue&type=script&lang=js&"
export * from "./TgCjNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports